import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { InitState } from '../state/init.state';
import { initFeatureStoreKey } from '../feature/init.feature';
import { Injectable } from '@angular/core';

// export const getInitState =
//   createFeatureSelector<InitState>(initFeatureStoreKey);

// export const getAccountInfo = createSelector(
//   getInitState,
//   (state) => state.accountInfo
// );

// export const getUserInfoLoaded = createSelector(
//   getInitState,
//   (state) => state.isUserInfoLoaded
// );

// export const getAccountUpdates = createSelector(
//   getInitState,
//   (state) => state.accountUpdates
// );

@Injectable({
  providedIn: 'root',
})
export class InitSelectors {
  // getAccountInfo$ = this.store.select(getAccountInfo);
  // isUserInfoLoaded$ = this.store.select(getUserInfoLoaded);
  // getAccountUpdates$ = this.store.select(getAccountUpdates);

  constructor(private store: Store<InitState>) {}
}
